import moment from 'moment'

const translations = {
  en: {
    now: "just now",
    today: "today at",
    yesterday: "yesterday at",
    days: "days ago",
    week: "a week ago",
    month: "a month ago",
  },
  ru: {
    now: "только что",
    today: "сегодня в",
    yesterday: "вчера в",
    days: "дня назад",
    week: "неделю назад",
    month: "месяц назад",
  },
  uk: {
    now: "щойно",
    today: "сьогодні о",
    yesterday: "вчора",
    days: "дні тому",
    week: "тиждень тому",
    month: "місяць тому",
  },
  ua: {
    now: "щойно",
    today: "сьогодні о",
    yesterday: "вчора",
    days: "дні тому",
    week: "тиждень тому",
    month: "місяць тому",
  },
};

export default function (timestamp, locale) {
    const diffSeconds = moment().diff(timestamp, 'seconds');
    const diffDays = moment().diff(timestamp, "days");

    const timeFmt = moment(timestamp).format('HH:mm');
    const dateFmt = moment(timestamp).format('DD.MM.YYYY');

    const localePack = translations[locale] || translations.en;

    if (diffSeconds < 60) {
        return localePack.now;
    }

    if (moment().isSame(timestamp, 'date')) {
        return `${localePack.today} ${timeFmt}`;
    }

    if (moment().subtract(1, 'day').isSame(timestamp, 'date')) {
        return `${localePack.yesterday} ${timeFmt}`;
    }

    if (diffDays < 6) {
        return `${Math.round(diffDays)} ${localePack.days}`;
    }

    if (diffDays < 30) {
        return ` ${localePack.week}`;
    }

    if (diffDays < 60) {
        return ` ${localePack.month}`;
    }

    return `${dateFmt} ${timeFmt}`;
}